import { useState } from "react";

export const validarNome = (valor) => valor.trim().split(/\s+/).filter(Boolean).length >= 2;
export const validarEmail = (valor) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor.trim());
export const validarTelefone = (valor) => {
  const digitos = valor.replace(/\D/g, "");
  return digitos.length >= 10 && digitos.length <= 11;
};
// Mascara (11) 9999-9999 / (11) 99999-9999, aplicada enquanto digita.
export const formatarTelefone = (valor) => {
  const digitos = valor.replace(/\D/g, "").slice(0, 11);
  if (digitos.length === 0) return "";
  if (digitos.length <= 2) return `(${digitos}`;
  if (digitos.length <= 6) return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`;
  if (digitos.length <= 10) return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
  return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
};

// Estado + validacao do formulario de inscricao do Grande Encontro do
// Associativismo — compartilhado entre a tela publica e a tela interna
// (equipe logada), pra manter os dois formularios sempre em sincronia.
// Edicao de outubro/2026: so nome, e-mail e telefone; todos presenciais.
const useInscricaoForm = () => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [aceiteLgpd, setAceiteLgpd] = useState(false);
  const [erros, setErros] = useState({ nome: "", email: "", telefone: "" });

  const formularioValido =
    validarNome(nome) &&
    validarEmail(email) &&
    validarTelefone(telefone) &&
    aceiteLgpd;

  const validarCampos = () => {
    const novosErros = {
      nome: validarNome(nome) ? "" : "Digite nome e sobrenome.",
      email: validarEmail(email) ? "" : "E-mail inválido.",
      telefone: validarTelefone(telefone) ? "" : "Telefone inválido. Use DDD + número.",
    };
    setErros(novosErros);
    return !Object.values(novosErros).some(Boolean) && formularioValido;
  };

  const payload = () => ({
    nome,
    email,
    telefone,
    aceiteLgpd,
  });

  const resetar = () => {
    setNome("");
    setEmail("");
    setTelefone("");
    setAceiteLgpd(false);
    setErros({ nome: "", email: "", telefone: "" });
  };

  return {
    nome, setNome,
    email, setEmail,
    telefone, setTelefone,
    aceiteLgpd, setAceiteLgpd,
    erros, setErros,
    formularioValido,
    validarCampos,
    payload,
    resetar,
  };
};

export default useInscricaoForm;
